import type { LayoutBlock } from '@web-studio/shared-schemas';
import { cateringInquiryFormDefault } from '../blocks/cateringInquiry';
import { footerStandardDefault } from '../blocks/footer';
import { heroFoodTruckStandardDefault } from '../blocks/heroVerticals';
import { navigationFoodTruckDefault } from '../blocks/navigationVerticals';
import { simpleMenuStripDefault } from '../blocks/simpleMenuStrip';
import { staticLocationTextDefault } from '../blocks/staticLocation';
import { weeklyScheduleRouteStripDefault } from '../blocks/weekSchedule';

/** Food truck / recommended — marketplace & design-lab preview. */
export const foodTruckRecommendedPage: LayoutBlock[] = [
  { ...navigationFoodTruckDefault, displayOrder: 0 },
  { ...heroFoodTruckStandardDefault, displayOrder: 1 },
  { ...staticLocationTextDefault, displayOrder: 2 },
  { ...simpleMenuStripDefault, displayOrder: 3 },
  { ...weeklyScheduleRouteStripDefault, displayOrder: 4 },
  { ...cateringInquiryFormDefault, displayOrder: 5 },
  { ...footerStandardDefault, displayOrder: 99 },
];
